export default __webpack_public_path__ + "static/media/ss4.bb9c5d43.JPG";